import { render } from "./inventory-report.vue?vue&type=template&id=6c5a488f"
import script from "./inventory-report.vue?vue&type=script&lang=js"
export * from "./inventory-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__